import React, { useContext, useState } from "react";

import { ApiRoutes, FetchContext, HttpMethods, ToastContext, } from "../../contexts";

import { useAggregatedState } from "../../../helpers";

export const ComuneContext = React.createContext(null);

const { Provider } = ComuneContext;

export const ComuneProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage,
        showLoadingMessage,
        closeLoadingMessage,
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        comune: null,
        competenze: null,
        messaggiCompetenze: null,
        comuni: [],
        comuniOptions: [],
        province: [],
        provinceOptions: [],
    });

    const { competenze, messaggiCompetenze } = state;

    const [isLoadingComune, setIsLoadingComune] = useState(false);
    const getComuneAsync = async (comuneId) => {
        try {
            setIsLoadingComune(true);
            const r = await fetchAuthorized(ApiRoutes.Comune.GetComune({ comuneId }), {
                method: HttpMethods.GET,
            });
            const result = await r.json();
            result.dataIstituzione = new Date(result.dataIstituzione);
            result.dataCessazione = result.dataCessazione
                ? new Date(result.dataCessazione)
                : null;
            setState({ comune: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingComune(false);
        }
    };

    const [isUpdatingComune, setIsUpdatingComune] = useState(false);
    const updateComuneAsync = async (comuneId, comune) => {
        try {
            setIsUpdatingComune(true);
            comune.anprId = parseInt(comune.anprId);
            const r = await fetchAuthorized(ApiRoutes.Comune.UpdateComune({ comuneId }), {
                method: HttpMethods.POST,
                body: JSON.stringify(comune),
            });
            const result = await r.json();
            result.dataIstituzione = new Date(result.dataIstituzione);
            result.dataCessazione = result.d;
            showSuccessMessage("Comune aggiornato");
            window.close();
        } catch (e) {
            console.debug(e);
        } finally {
            setIsUpdatingComune(false);
        }
    };

    const [isAddingComune, setIsAddingComune] = useState(false);
    const addComuneAsync = async (comune) => {
        try {
            setIsAddingComune(true);

            if (comune.anprId == 0) {
                comune.anprId = null;
            }
            const r = await fetchAuthorized(ApiRoutes.Comune.AddComune(), {
                method: HttpMethods.PUT,
                body: JSON.stringify(comune),
            });
            const result = await r.json();
            setState({
                comune: {
                    ...result,
                    dataIstituzione: new Date(result.dataIstituzione),
                    fineValidita: result.dataCessazione
                        ? new Date(result.dataCessazione)
                        : null,
                },
            });
            showSuccessMessage("Comune creato");
            window.close();
        } catch (e) {
            console.debug(e);
        } finally {
            setIsAddingComune(false);
        }
    };

    const [isLoadingCompetenze, setIsLoadingCompetenze] = useState(false);
    const getCompetenzeAsync = async (
        comuneId,
        pageIndex = 0,
        pageSize = 100
    ) => {
        try {
            setIsLoadingCompetenze(true);
            const r1 = await fetchAuthorized(
                ApiRoutes.Competenza.GetCompetenze({ pageIndex: 0, pageSize: 1000 }),
                {
                    method: HttpMethods.GET,
                }
            );
            const list1 = await r1.json();
            setState({ messaggiCompetenze: list1.result });

            const r2 = await fetchAuthorized(
                ApiRoutes.Comune.GetCompetenze({ comuneId, pageIndex, pageSize }),
                {
                    method: HttpMethods.GET,
                }
            );
            const list2 = await r2.json();
            list2.result.forEach(x => {
                x.inizioValidita = new Date(x.inizioValidita);
                x.fineValidita = x.fineValidita ? new Date(x.fineValidita) : null;
                if (x.competenza) {
                    x.competenza.inizioValidita = new Date(x.competenza.inizioValidita);
                    x.competenza.fineValidita = x.competenza.fineValidita ? new Date(x.competenza.fineValidita) : null;
                }
                if (x.ufficio) {
                    x.ufficio.inizioValidita = new Date(x.ufficio.inizioValidita);
                    x.ufficio.fineValidita = x.ufficio.fineValidita ? new Date(x.ufficio.fineValidita) : null;
                    if (x.ufficio.tipoUfficio) {
                        x.ufficio.tipoUfficio.inizioValidita = new Date(x.ufficio.tipoUfficio.inizioValidita);
                        x.ufficio.tipoUfficio.fineValidita = x.ufficio.tipoUfficio.fineValidita ? new Date(x.ufficio.tipoUfficio.fineValidita) : null;
                    }
                }
                if (x.comune) {
                    x.comune.dataIstituzione = new Date(x.comune.dataIstituzione);
                    x.comune.dataCessazione = x.comune.dataCessazione ? new Date(x.comune.dataCessazione) : null;
                    if (x.comune.provincia) {
                        x.comune.provincia.inizioValidita = new Date(x.comune.provincia.inizioValidita);
                        x.comune.provincia.fineValidita = x.comune.provincia.fineValidita ? new Date(x.comune.provincia.fineValidita) : null;
                        if (x.comune.provincia.regione) {
                            x.comune.provincia.regione.inizioValidita = new Date(x.comune.provincia.regione.inizioValidita);
                            x.comune.provincia.regione.fineValidita = x.comune.provincia.regione.fineValidita ? new Date(x.comune.provincia.regione.fineValidita) : null;
                        }
                    }
                }
            });
            list2.result.forEach(x => {
                let competenza = list1.result.find(y => x.competenzaId == y.id);
                if (!x.ufficioId) x.messaggio = competenza.messaggioDefault;
            });
            list2.result.sort((a, b) => a - b);
            setState({ competenze: list2 });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingCompetenze(false);
        }
    };

    const [
        isDeletingUfficioComuneCompetenza,
        setIsDeletingUfficioComuneCompetenza,
    ] = useState(false);


    const deleteUfficioComuneCompetenzaAsync = async (comuneId, competenzaId) => {
        try {
            setIsDeletingUfficioComuneCompetenza(true);
            const r = await fetchAuthorized(
                ApiRoutes.Comune.DeleteCompetenza({ comuneId, competenzaId }),
                {
                    method: HttpMethods.DELETE,
                }
            );

            var tempCompetenza = competenze?.result.find(x => x.competenzaId == competenzaId);
            tempCompetenza.ufficio.nome = null;
            tempCompetenza.ufficioId = null;

            let messaggioDefault = messaggiCompetenze.find(x => x.id == tempCompetenza.competenzaId).messaggioDefault;
            if (!tempCompetenza.messaggio) tempCompetenza.messaggio = messaggioDefault;

            setState({ competenze: competenze });
            showSuccessMessage(
                `Comune con id ${competenzaId} del comune con id ${comuneId}. Ufficio rimosso.`
            );
        } catch (e) {
            console.debug(e);
        } finally {
            setIsDeletingUfficioComuneCompetenza(false);
        }
    };

    const [isLoadingComuni, setIsLoadingComuni] = useState(false);
    const getComuniAsync = async (term = null, pageSize = 100, pageIndex = 0) => {
        try {
            setIsLoadingComuni(true);
            const r = await fetchAuthorized(
                ApiRoutes.Comune.GetComuni({ term, pageIndex, pageSize }),
                {
                    method: HttpMethods.GET,
                }
            );
            const list = await r.json();
            list.result.forEach((x) => {
                x.dataIstituzione = new Date(x.dataIstituzione);
                if (x.dataCessazione)
                    x.dataCessazione = new Date(x.dataCessazione);
            });
            const comuniOptions = list.result
                .map((e) => {
                    let inizio = `(${e.dataIstituzione.getFullYear().toString().padStart(4, '0')}-${(e.dataIstituzione.getMonth() + 1).toString().padStart(2, '0')}-${e.dataIstituzione.getDate().toString().padStart(2, '0')})`;
                    let fine = e.dataCessazione ? `(${e.dataCessazione.getFullYear().toString().padStart(4, '0')}-${(e.dataCessazione.getMonth() + 1).toString().padStart(2, '0')}-${e.dataCessazione.getDate().toString().padStart(2, '0')})` : null;
                    return {
                        comuneId: e.id,
                        label: `${e.denominazioneIt} ${inizio}` + (fine ? ` - ${fine}` : ''),
                    };
                })
                .sort((a, b) => b.label?.toLowerCase().localeCompare(a.label?.toLowerCase()));
            setState({
                comuni: list,
                comuniOptions: comuniOptions,
            });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingComuni(false);
        }
    };

    const [isImportingCompetenze, setIsImportingCompetenze] = useState(false);
    const importCompetenzeAsync = async (comuneId, importComuneId) => {
        try {
            setIsImportingCompetenze(true);
            const r = await fetchAuthorized(
                ApiRoutes.Comune.ImportCompetenze({ comuneId, importComuneId }),
                {
                    method: HttpMethods.POST,
                }
            );
            const result = await r.json();
            setState({ competenze: result });
            showSuccessMessage("Competenze importate");
        } catch (e) {
            console.debug(e);
        } finally {
            setIsImportingCompetenze(false);
        }
    };

    const [isLoadingProvince, setIsLoadingProvince] = useState(false);
    const getProvinceAsync = async (
        term = null,
        pageIndex = 0,
        pageSize = 1000
    ) => {
        try {
            setIsLoadingProvince(true);
            const r = await fetchAuthorized(
                ApiRoutes.Provincia.GetProvince({ term, pageIndex, pageSize }),
                {
                    method: HttpMethods.GET,
                }
            );
            const list = await r.json();
            setState({
                province: list,
                provinceOptions: list.result
                    .map((e) => {
                        return {
                            provinciaId: e.id,
                            label: `${e.descrizione} (${e.sigla})`,
                        };
                    })
                    .sort((a, b) => a.label.localeCompare(b.label)),
            });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingProvince(false);
        }
    };

    return (
        <Provider
            value={{
                state,
                setState,

                isLoadingComune,
                getComuneAsync,

                isUpdatingComune,
                updateComuneAsync,

                isAddingComune,
                addComuneAsync,

                isLoadingCompetenze,
                getCompetenzeAsync,

                isDeletingUfficioComuneCompetenza,
                deleteUfficioComuneCompetenzaAsync,

                isLoadingComuni,
                getComuniAsync,

                isImportingCompetenze,
                importCompetenzeAsync,

                isLoadingProvince,
                getProvinceAsync,
            }}
        >
            {props.children}
        </Provider>
    );
};
